import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`

* {
  box-sizing: border-box;
  margin: 0;
}
body {
  background-color: rgba(215, 215, 215);
  font-family: 'Space Mono', monospace;
  font-size: calc(42% + 1.2vmin); 
  padding: 1vmax 5vw 2vw 10vw;
  color: black;
}
p{
  line-height: 28px;
}
a{
  text-decoration: none;
  color: black;
}
.light {
  color: rgb(176,176,176);
}
.pd-bt{
  padding-bottom: 20px;
}
.ab-br {
  border-top: 2px solid rgb(175, 175, 175);
  padding: 80px 0;
}
.prohed {
  border: 2px solid rgb(175, 175, 175);
}


`;
export default GlobalStyle;
